import { NavLink, useLocation } from 'react-router-dom';

const navItems = [
  { to: '/', icon: '🏠', label: 'Home', end: true },
  { to: '/agencies', icon: '🏢', label: 'Agenturen', end: false },
  { to: '/dashboard', icon: '📊', label: 'Dashboard', end: true },
];

export function Navigation(): JSX.Element | null {
  const location = useLocation();

  // Navigation im Rating-Flow und Evaluate-Flow ausblenden
  const isRatingFlow =
    location.pathname.startsWith('/rating') || location.pathname.startsWith('/evaluate');
  if (isRatingFlow) return null;

  return (
    <nav
      className="shrink-0 bg-white/95 backdrop-blur-md border-t border-charcoal-100 px-4 py-2 safe-area-bottom"
      style={{ zIndex: 'var(--z-sticky)' }}
      aria-label="Hauptnavigation"
    >
      <ul className="flex justify-around max-w-md mx-auto list-none m-0 p-0">
        {navItems.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              end={item.end}
              aria-label={item.label}
              aria-current={location.pathname === item.to || (item.to !== '/' && location.pathname.startsWith(item.to)) ? 'page' : undefined}
              className={({ isActive }) =>
                `flex flex-col items-center min-h-11 min-w-16 py-2 px-4 rounded-xl transition-all duration-200
                 focus:outline-none focus-visible:ring-2 focus-visible:ring-cherry-600 focus-visible:ring-offset-2
                 ${isActive
                  ? 'text-cherry-600 bg-cherry-50'
                  : 'text-charcoal-500 hover:bg-charcoal-50 hover:text-charcoal-700'
                }`
              }
            >
              <span className="text-xl" aria-hidden="true">{item.icon}</span>
              <span className="text-xs mt-1 font-medium">{item.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
